import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { mapProps, lifecycle } from 'recompose'
import * as R from 'ramda'

import getSelectors from './selectors'
import getActions from './actions'
import withSagas from './sagas'

import {
  getPath,
  combinePath
} from 'containers/Form/util'

import {
  RiskSlider,
  withConnect,
  withReducer
} from 'containers/Form/Slider/index'

const withRiskConnect = (path, id) => {
  const valuePath = getPath(path, id)
  const combinedPath = combinePath(path, id)
  const {
    runRiskValidation,
  } = getActions(valuePath)
  const {
    riskSelector,
    isRiskSelector
  } = getSelectors(combinedPath)

  const mapStateToProps = (state) => {
    return {
      risks: riskSelector(state),
      isRisk: isRiskSelector(state),
    }
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      runRiskValidation: () => dispatch(runRiskValidation()),
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

const withRisk = (path, id) => R.compose(
  withSagas(path, id),
  withRiskConnect(path, id),
  lifecycle({
    componentDidMount() {
      this.props.runRiskValidation()
    }
  })
)

export {
  withReducer,
  withConnect,
  withRisk,
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
  withRisk(path, id),
)(RiskSlider))
